import * as elog from '@reverbdotcom/commons/dist/elog';

function trackArticleView(articleId, utmCampaign) {
  const event = new elog.events.ArticleView({
    url: window.location.href,
    referer: document.referrer,
    utm_campaign: utmCampaign || '',
    article_id: articleId.toString(),
  });

  elog.track(event);
}

export default {
  trackArticleView,
};
